export default {
  "content": "_content_ouj2i_1",
  "--hover": "_--hover_ouj2i_1",
  "--hover-disabled": "_--hover-disabled_ouj2i_1",
  "inner": "_inner_ouj2i_1",
  "--width-trigger": "_--width-trigger_ouj2i_1",
  "--position-top": "_--position-top_ouj2i_1",
  "--position-top-end": "_--position-top-end_ouj2i_1",
  "--position-top-start": "_--position-top-start_ouj2i_1",
  "--position-bottom": "_--position-bottom_ouj2i_1",
  "--position-bottom-end": "_--position-bottom-end_ouj2i_1",
  "--position-bottom-start": "_--position-bottom-start_ouj2i_1",
  "--position-start": "_--position-start_ouj2i_1",
  "--position-start-bottom": "_--position-start-bottom_ouj2i_1",
  "--position-start-top": "_--position-start-top_ouj2i_1",
  "--position-end": "_--position-end_ouj2i_1",
  "--position-end-bottom": "_--position-end-bottom_ouj2i_1",
  "--position-end-top": "_--position-end-top_ouj2i_1",
  "--visible": "_--visible_ouj2i_1",
  "--animated": "_--animated_ouj2i_1"
};import "ni:sha-256;wGZiro7fSKGlyQ7TICRnHMy5A2izhPenPIjMg3hjvnk";